import React from "react";
import { AppUser } from "../../services/TimeTracking/types";

const SelectedUserCard: React.FC<{ user: AppUser }> = ({ user }) => (
    <div className="border p-4 rounded-md shadow mt-4 max-w-md">
      <img src={user.photo} className="w-28 h-28 rounded-full mx-auto mb-2" />
      <h3 className="text-lg font-bold text-center">{user.firstName} {user.lastName}</h3>
      <p className="text-center text-sm text-gray-500">{user.email}</p>
    </div>
  );
  
  export default SelectedUserCard;
  